FeedsApp.Views.NuFeedDefinition = ReadOnlyViewStandardModelEdition.extend({
    containerSelector: '.feed-definition-container',
    templateUrl: '/assets/js/feeds/history/templates/feed-definition.html'
});